export default __webpack_public_path__ + "static/media/jamstack.8cf7e2ca.svg";